/* eslint-disable import/prefer-default-export */
export const AI_SEARCH_ENDPOINT = 'specialty-ai-search/';
